<template>
    <div class="card card--shadow">
        <img v-if="cardImageSrc" :src="cardImageSrc" class="card-img-top" :alt="cardImageAltText">
        <div class="card-body">
            <h5 class="card-title" v-if="cardTitle">{{ cardTitle }}</h5>
            <p class="card-text" v-if="cardText">{{ cardText }}</p>
            <a v-if="cardLinkUrl && cardLinkText" :href="cardLinkUrl" class="btn btn-primary">{{ cardLinkText }}</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'card-element',
    props: {
      cardTitle: String,
      cardText: String,
      cardImageSrc: String,
      cardImageAltText: String,
      cardLinkText: String,
      cardLinkUrl: String
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.card {
    margin-bottom: 25px;
    border-radius: 5px;
    border: none;
}
.card--shadow {
    -webkit-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.25);
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.25);
}
.card-img-top {
    max-height: 225px;
}
</style>